import { forwardRef, ForwardRefRenderFunction, HTMLAttributes } from 'react';

type Props = Omit<HTMLAttributes<HTMLDivElement>, 'className'>;

const CheckboxFieldNoteRenderFunction: ForwardRefRenderFunction<
  HTMLDivElement,
  Props
> = (attrs, ref) => {
  return (
    <div {...attrs} ref={ref} className="text-base text-marine-high-emphasis" />
  );
};

export const CheckboxFieldNote = forwardRef<HTMLDivElement, Props>(
  CheckboxFieldNoteRenderFunction,
);
